import { Button, Divider, Spacer, Text } from 'internalLibrary';
import { FC } from 'react';
import { useCalculator } from 'ui/components/CalculatorProvider';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import Slider from 'ui/components/Slider/Slider';
import styles from './LoanCalculatorSettings.module.scss';

interface LoanCalculatorSettingsProps {
  onSubmit?: (amount: number) => void;
}
const LoanCalculatorSettings: FC<LoanCalculatorSettingsProps> = (props) => {
  const { min, max, step, shouldDisplayLoading, amount, onAmountChange } =
    useCalculator();
  const { onSubmit } = props;
  const { t } = useTranslation();

  const submitted: React.FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    if (amount !== undefined) onSubmit?.(amount);
  };

  return (
    <form
      className={classes([styles.form, shouldDisplayLoading && styles.loading])}
      data-test="css-Edit-Request-Container"
      onSubmit={submitted}
    >
      <div className={styles.desktop}>
        <Spacer
          paddingBottom="20px"
          className={styles['calculator-title-wrapper']}
        >
          <Text
            text={t('calculator_title')}
            className={styles['calculator-title']}
          />
          <Divider direction="horizontal" />
        </Spacer>
        {max !== undefined && min !== undefined && (
          <Spacer
            className={classes(
              styles['slider-wrapper'],
              styles['slider-wrapper-first'],
            )}
            paddingTop="40px"
            paddingBottom="40px"
          >
            <Slider
              className={styles['slider-element']}
              disabled={shouldDisplayLoading}
              loading={shouldDisplayLoading}
              max={max}
              min={min}
              step={step}
              onChange={onAmountChange}
              units={t('currencySymbol')}
              value={amount}
            />
          </Spacer>
        )}
      </div>
      <Button
        type="submit"
        fill={true}
        loading={shouldDisplayLoading}
        dataTest="cssEditRequestButton"
      >
        {t('calculator_confirmChanges')}
      </Button>
    </form>
  );
};

export default LoanCalculatorSettings;
